import { RootState } from 'reducers';
import { OptionProps } from 'react-apollo';
import {
  IdeaPositionDetailsQuery,
  IdeaPositionDetailsQueryVariables,
} from './__generated__/IdeaPositionDetailsQuery';
import { Props } from '.';

export const mapStateToProps = (state: RootState) => state.components.ideaPositionDetails;

export type SelectorResult = ReturnType<typeof mapStateToProps>;

export const responseToProps = ({
  data,
}: OptionProps<
  Props & SelectorResult,
  IdeaPositionDetailsQuery,
  IdeaPositionDetailsQueryVariables
>) => {
  if (!data || !data.lab || !data.lab.buyAndHoldPosition) {
    return {
      loading: !data || data.loading,
    };
  }
  return {
    position: data.lab.buyAndHoldPosition,
    loading: data.loading,
  };
};

export type Data = ReturnType<typeof responseToProps>;
